module.exports = __webpack_public_path__ + "img/world_map_.5c5eefef.svg";